/* eslint-disable import/prefer-default-export */
import { isNil } from 'lodash-es'

function createStorage(storage) {
	return {
		key(index) {
			return storage.key(index)
		},
		get(keyName) {
			return storage.getItem(keyName) !== undefined
				? JSON.parse(storage.getItem(keyName))
				: storage.getItem(keyName)
		},
		set(keyName, keyValue) {
			return storage.setItem(keyName, JSON.stringify(keyValue))
		},
		remove(keyName) {
			return storage.removeItem(keyName)
		},
		has(keyName: string) {
			return !isNil(storage.getItem(keyName))
		},
		clear() {
			return storage.clear()
		},
		get length() {
			return storage.length
		},
	}
}

export const storage = createStorage(sessionStorage)
